module.exports = __webpack_public_path__ + "img/domain-registration.c8ffbec9.svg";